module.exports = __webpack_public_path__ + "img/img46.7322c65e.png";